import { ICellEditorParams } from 'ag-grid-community'
import React, { useContext, useImperativeHandle, useState } from 'react'
import {
  MultipleNormalizedManufacturerSearch,
  NormalizedManufacturerSearch,
} from '../../../../common/components/NormalizedManufacturerSearch'
import { EditingAgGridContext } from '../MarkupRules'

export const AgNormalizedSupplierSearch = React.forwardRef<{}, ICellEditorParams>((params, ref) => {
  const [normalizedCurvo, setNormalizedCurvo] = useState<string | undefined>(params.value)

  useImperativeHandle(ref, () => ({
    getValue: () => normalizedCurvo,
  }))

  return (
    <NormalizedManufacturerSearch
      allowClear
      value={normalizedCurvo}
      onChange={v => {
        setNormalizedCurvo(v)
      }}
      placeholder="Select Vendor"
    />
  )
})

export const AgMultipleNormalizedManufacturerSearch = React.forwardRef<{}, ICellEditorParams>((params, ref) => {
  const [normalizedCurvo, setNormalizedCurvo] = useState<string[]>(params.value || [])
  const { onChangeEditingItem, editingItem } = useContext(EditingAgGridContext)

  useImperativeHandle(ref, () => ({
    getValue: () => normalizedCurvo,
  }))

  return (
    <MultipleNormalizedManufacturerSearch
      disabled={!!editingItem?.marketBasket?.length || !!editingItem?.unspsc?.length}
      style={{
        visibility: !!editingItem?.marketBasket?.length || !!editingItem?.unspsc?.length ? 'hidden' : 'visible',
      }}
      allowClear
      value={normalizedCurvo}
      onChange={v => {
        onChangeEditingItem(prev => ({
          ...prev,
          manufacturer: v,
        }))
        setNormalizedCurvo(v)
      }}
      maxTagCount="responsive"
      labelInValue={false}
      placeholder="Select Manufacturer"
    />
  )
})
